import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../templates/Input";
import {
  clearHackathonError,
  createHackathon,
} from "../../store/hackathonSlice";
import { clearJobError } from "../../store/jobSlice";
import { setPopup } from "../../store/popupSlice";

function AddHackathon() {
  const [error, setError] = useState("");
  const errorFromStore = useSelector((state) => state.hackathon.error);
  const [formData, setFormData] = useState({});
  const loading = useSelector((state) => state.hackathon.loading);
  const dispatch = useDispatch();

  const inputFields = [
    {
      id: "title",
      label: "Title",
      required: true,
      placeholder: "Enter Hackathon Title",
    },

    {
      id: "organizer",
      label: "Organizer",
      required: true,
      type: "text",
    },
    {
      id: "startDate",
      label: "Start Date",

      type: "date",
    },
    {
      id: "endDate",
      label: "End Date",

      type: "date",
    },
    { id: "mode", label: "Mode" },
    { id: "description", label: "Description", type: "rich-text" },
    { id: "registrationLink", label: "Registration Link", required: true },
  ];

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setError("");
  };

  const handleHackathonSubmission = async () => {
    const payload = { ...formData };
    const result = await dispatch(createHackathon(payload));

    if (result.payload?.success) {
      setFormData({});
      setError("");
      dispatch(clearJobError());

      dispatch(
        setPopup({
          message: `Hackathon "${result.payload.data.Title}" posted successfully!`,
          type: "success",
        })
      );
    } else {
      dispatch(
        setPopup({
          message: result.payload?.message || "Error submitting hackathon",
          type: "error",
        })
      );
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    dispatch(clearHackathonError());
  }, [dispatch]);

  return (
    <div className="min-h-screen bg-gradient-to-r from-indigo-100 to-purple-100 flex items-center justify-center px-4 py-12 mt-[9vh]">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl p-10 border-t-4 border-purple-500">
        <h2 className="text-3xl font-extrabold text-center text-purple-700 mb-8">
          Add Hackathon
        </h2>

        {(error || errorFromStore) && (
          <div className="bg-red-100 text-red-700 p-3 mb-6 rounded-lg shadow-sm text-center">
            {error || errorFromStore}
          </div>
        )}

        <div className="space-y-6">
          <Input
            fields={inputFields}
            onChange={handleChange}
            formData={formData}
          />
          <button
            type="button"
            disabled={loading}
            onClick={handleHackathonSubmission}
            className="w-full py-3 bg-purple-600 text-white font-semibold rounded-lg shadow hover:bg-purple-700 transition duration-300"
          >
            {loading ? "Adding Hackathon..." : "Add Hackathon"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddHackathon;
